import axios from "axios";

const axiosInstance = axios.create({
  headers: {
    "Content-Type": "application/json",
  },
});

axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("authToken");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;

  },
  (error) => Promise.reject(error)
);


axiosInstance.interceptors.response.use(
  (response) => {
    const newToken = response.headers["x-new-token"];
    if (newToken) {
      localStorage.setItem("authToken", newToken);
    }
    return response;
  },

  (error) => {
  if (
    error.response &&
    (
      (error.response.status === 401 &&
        (error.response.data?.message?.toLowerCase() === "invalid or expired token") ||
      error.response.data?.error?.toLowerCase() === "unauthorized" )
      
    )
  ) {
      localStorage.removeItem("authToken");
      localStorage.removeItem("user_id");
      localStorage.removeItem("privilege");
      localStorage.removeItem("user_name");

      // Optional: Clear cookies or session flags
      document.cookie = "auth_token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
      sessionStorage.setItem("logout", "true");

      window.location.href = "/login";
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
